<template>
  <img src="https://nbgz-pmis-1257839135.cos.ap-shanghai.myqcloud.com/beauty/new.gif" style="width:30px;height:13px;display:inline-block;" />
</template>

<script>
export default {

};
</script>

<style>

</style>
